'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}let

ModalSubmissionResult=function(){
function ModalSubmissionResult(type){_classCallCheck(this,ModalSubmissionResult);
this._type=type;
}_createClass(ModalSubmissionResult,[{key:'type',get:function()

{
return this._type;
}}]);return ModalSubmissionResult}();let


KeepOpen=function(_ModalSubmissionResul){_inherits(KeepOpen,_ModalSubmissionResul);
function KeepOpen(){_classCallCheck(this,KeepOpen);return _possibleConstructorReturn(this,
_ModalSubmissionResul.call(this,'KeepOpen'));
}return KeepOpen}(ModalSubmissionResult);let


Abandon=function(_ModalSubmissionResul2){_inherits(Abandon,_ModalSubmissionResul2);
function Abandon(){_classCallCheck(this,Abandon);return _possibleConstructorReturn(this,
_ModalSubmissionResul2.call(this,'Abandon'));
}return Abandon}(ModalSubmissionResult);let


Close=function(_ModalSubmissionResul3){_inherits(Close,_ModalSubmissionResul3);
function Close(result){_classCallCheck(this,Close);var _this3=_possibleConstructorReturn(this,
_ModalSubmissionResul3.call(this,'Close'));
_this3._result=result;return _this3;
}_createClass(Close,[{key:'result',get:function()

{
return this._result;
}}]);return Close}(ModalSubmissionResult);let


Dismiss=function(_ModalSubmissionResul4){_inherits(Dismiss,_ModalSubmissionResul4);
function Dismiss(reason){_classCallCheck(this,Dismiss);var _this4=_possibleConstructorReturn(this,
_ModalSubmissionResul4.call(this,'Dismiss'));
_this4._reason=reason;return _this4;
}_createClass(Dismiss,[{key:'reason',get:function()

{
return this._reason;
}}]);return Dismiss}(ModalSubmissionResult);


module.exports=ModalSubmissionResult;
module.exports.KeepOpen=new KeepOpen;
module.exports.Abandon=new Abandon;
module.exports.Close=function(result){return new Close(result)};
module.exports.Dismiss=function(reason){return new Dismiss(reason)};
module.exports.FromError=function(error){return error.constructor.name==='AccessDeniedError'?ModalSubmissionResult.KeepOpen:ModalSubmissionResult.Abandon};
//# sourceMappingURL=modalSubmissionResult.js.map
